export const API = {
  video: 'http://cloudthing.streaming.mediaservices.windows.net',
  enquiry:
    'https://ct-azie-prfun02.azurewebsites.net/api/enquiry?code=d1yqr4fr8gmW6o4n1iHQwwwd0rEeIPjv73aU/McN9dKHArklaypIeA==',
}

export const DRAWER = {
  enter: 150,
  exit: 50,
}

export const BACKGROUNDS = {
  b1: 'linear-gradient(180deg, #e14e23, #f5d657)',
  b2: 'linear-gradient(270deg, #8cc63f, #0c1876)',
}

export const VIDEOS = {
  v1: `${
    API.video
  }/b52419d5-666e-4417-b8e6-033baba8dcdb/stream-test-revised.ism/manifest(format=mpd-time-csf).mpd`,
}

export const TWITTER_HANDLE = {
  site: '@cloud_thing',
}

export const CONFIG = {
  baseUrl: 'http://www.cloudthing.com',
}

export const CONTENTTYPES = {
  section: 'SECTION',
  quote: 'QUOTE',
  video: 'VIDEO',
  contentLink: 'CONTENT_LINK',
}

export const SERVICES_ORDER = []

export const GRADIENTS = {
  blue:
    'linear-gradient(to right top, #41495e, #4b677c, #578796, #6ca7a8, #8fc7b5)',
  red:
    'linear-gradient(to right top, #ea3b4c, #e3475b, #db5268, #d15c73, #c6667c)',
  purple:
    'linear-gradient(to right top, #3e2772, #4f3291, #613eb1, #734ad3, #8656f5)',
  pink:
    'linear-gradient(to right top, #b8557b, #ba398b, #ae1da6, #8c17c9, #072ff0)',
  green:
    'linear-gradient(to right top, #20cf35, #73ce17, #a2cd00, #c8c900, #eac518)',
  cyan:
    'linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
  orange:
    'linear-gradient(to right top, #defc00, #e7ed00, #edde00, #f1cf00, #f3c000, #fbae1c, #ff9c2e, #ff8b3e, #ff735d, #ff5d84, #ff54b2, #fb5fe1)',
}



// WEBPACK FOOTER //
// ./src/utils/constants.js